'use client';

import { GoogleTagManager } from '@next/third-parties/google';

import { publicEnv } from '~/definitions/publicEnv';

export const GoogleAnalytics = () =>
  publicEnv.CORE_PLANNER_GOOGLE_TAG_MANAGER_ID && publicEnv.APP_ENV === 'production' ? (
    <GoogleTagManager gtmId={publicEnv.CORE_PLANNER_GOOGLE_TAG_MANAGER_ID} />
  ) : null;
